import React from 'react';

import './style.css';

import { Call } from '../../call';
import { PhoneButton } from '../../components/PhoneButton/PhoneButton';
import { useRedirect } from '../../components/Router/Router';
import { callRoute, contactsRoute, gameRoute } from '../../routes';
import { calls, randomCall } from '../../content';
import { AdButton } from '../../components/AdButton/AdButton';
import { useMuted } from '../../components/AudioProvider/AudioProvider';

const Separator: React.FC = () => {
    return (
        <div style={{
            height: '0.1rem',
            width: '21.6rem',
            backgroundColor: '#7D7D7D',
            margin: '0.1rem auto',
        }} />
    );
};

interface ContactProps {
    call: Call;
}

const Contact: React.FC<ContactProps> = (props) => {
    const redirect = useRedirect();

    const call = React.useCallback(() => {
        props.call.available = true;

        redirect(callRoute({
            call: props.call,
            type: 'outgoing',
            onHang: () => redirect(contactsRoute({})),
        }));
    }, [props.call, redirect]);

    const button = (
        <PhoneButton type='call' onClick={call} />
    );

    return (
        <div className='contacts-list__item'>
            <img className='contacts-list__item__image' src={props.call.image} />
            <div className='contacts-list__item__text'>
                {props.call.personName}
            </div>
            {props.call.forAdvertisement ? (
                <AdButton storageKey={props.call.id} onRewarded={call}>
                    {button}
                </AdButton>
            ) : button}
        </div>
    );
};

export interface ContactsListProps { }

let called = false;
const threshold = 4_000;

export const ContactsList: React.FC<ContactsListProps> = () => {
    const redirect = useRedirect();
    const muted = useMuted();

    const goToContactsPage = React.useCallback(() => {
        redirect(contactsRoute({}));
    }, []);

    const goToGamePage = React.useCallback(() => {
        redirect(gameRoute({}));
    }, []);


    React.useEffect(() => {
        if (!randomCall.available || muted) {
            return;
        }

        const startTime = Date.now();
        const interval = setInterval(() => {
            if (calls.every(call => call.available) && Date.now() - startTime >= threshold && !called) {
                called = true;
                redirect(callRoute({
                    call: randomCall,
                    type: 'incoming',
                    onHang: goToContactsPage,
                }));
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [muted]);

    return (
        <div className='contacts-list__root'>
            <div className='contacts-list__header'>Контакты</div>
            {
                calls.flatMap((call) => ([
                    <Contact call={call} key={call.id} />,
                    <Separator key={`${call.id}-separator`} />,
                ]))
            }

            <div className='contacts-list__item contacts-list__play-button-item' onClick={goToGamePage}>
                <div className='contacts-list__play-button'>
                    Играть в &quot;Найди Рому&quot;
                </div>
            </div>
        </div>
    );
}; 
